import { saveDocument } from '../documentDownload';
import { useState } from 'react';
import { useI18n } from '@/hooks/useI18n';
import { workflowApi, type Resource } from '../workflowApi';
import { Card } from './dp120Parts';
import { DoctoralDocumentPreview } from './DoctoralDocumentPreview';

export function Resources({ resources }: { resources: Resource[] }) {
  const { locale } = useI18n();
  const [search, setSearch] = useState('');
  const [error, setError] = useState('');
  const [preview, setPreview] = useState<Resource>();
  const labels = {
    ru: [
      'Поиск образца, инструкции или консультанта',
      'Открыть',
      'Скачать',
      'Файл образца ещё не доставлен',
      'В этом разделе нет утверждённых образцов.',
    ],
    kz: [
      'Үлгі, нұсқаулық немесе кеңесші іздеу',
      'Ашу',
      'Жүктеу',
      'Үлгі файлы әлі жеткізілмеген',
      'Бұл бөлімде бекітілген үлгілер жоқ.',
    ],
    en: [
      'Find a template, instruction or consultant',
      'Open',
      'Download',
      'The template file has not been delivered yet',
      'No approved templates in this section.',
    ],
  }[locale];
  return (
    <>
      {preview && (
        <DoctoralDocumentPreview
          key={preview.id}
          title={preview.filename || preview.title}
          load={() => workflowApi.templatePreview(preview.id, preview.edition_id)}
          download={() => workflowApi.template(preview.id, preview.edition_id)}
          onClose={() => setPreview(undefined)}
        />
      )}
      {error && <p role="alert">{error}</p>}
      <label className="dp120-field">
        <span>{labels[0]}</span>
        <input value={search} onChange={(e) => setSearch(e.target.value)} />
      </label>
      {!resources.length && <p>{labels[4]}</p>}
      {Object.entries(
        resources
          .filter((r) => `${r.title} ${r.group}`.toLowerCase().includes(search.toLowerCase()))
          .reduce<Record<string, Resource[]>>((groups, r) => {
            (groups[r.group] ??= []).push(r);
            return groups;
          }, {}),
      ).map(([group, items]) => (
        <Card key={group} title={group} span="span12">
          <div className="dp120-doc-list">
            {items.map((r) => (
              <div key={r.id} className="dp120-doc">
                <div>
                  <strong>
                    {r.number ? `${r.number}. ` : ''}
                    {r.title}
                  </strong>
                  {r.description?.[locale] && <p>{r.description[locale]}</p>}
                  {r.available === false && <p className="dp120-badge warn">{labels[3]}</p>}
                </div>
                <div className="dp120-row-actions">
                  {r.local_available || r.edition_id ? (
                    <>
                      <button className="dp120-mini" onClick={() => setPreview(r)}>
                        {labels[1]}
                      </button>
                      <button
                        className="dp120-mini gold"
                        onClick={() =>
                          void workflowApi
                            .template(r.id, r.edition_id)
                            .then((result) => saveDocument(result, r.filename || r.title))
                            .catch((e: unknown) =>
                              setError(
                                e instanceof Error ? e.message : 'Не удалось скачать образец',
                              ),
                            )
                        }
                      >
                        {labels[2]}
                      </button>
                    </>
                  ) : r.fileId ? (
                    <>
                      <a
                        className="dp120-mini"
                        href={`https://drive.google.com/file/d/${encodeURIComponent(r.fileId)}/view`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {labels[1]}
                      </a>
                      <a
                        className="dp120-mini gold"
                        href={`https://drive.google.com/uc?export=download&id=${encodeURIComponent(r.fileId)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {labels[2]}
                      </a>
                    </>
                  ) : (
                    <>
                      <button className="dp120-mini" disabled>
                        {labels[1]}
                      </button>
                      <button className="dp120-mini gold" disabled>
                        {labels[2]}
                      </button>
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </Card>
      ))}
    </>
  );
}
